// eslint-disable-next-line import/no-anonymous-default-export


import { PAI } from "../utils/RouteHelper/IBP/PAI";
import { SNOP } from "../utils/RouteHelper/IBP/SNOP";
import { SNOE } from "../utils/RouteHelper/IOP/SNOE";
/* 
List of All the literals and constants used in Project
*/
const constKeys = {
  api: "",
  API_METHOD_POST: "POST",
  API_METHOD_GET: "GET",
  API_METHOD_PUT: "PUT",
  API_METHOD_PATCH: "PATCH",
  API_METHOD_DELETE: "DELETE",
  API_METHOD_HEAD: "HEAD",
  FORM_VALIDATION_EXAMPLE: "Form Inputs Validation Example",
  ERROR_BOUNDARY_EXAMPLE: "Error Boundary Example",
  API_RESPONSE_ERROR: "Something went wrong with API",
  GLOBAL_ERROR: "Something went wrong",
};

export const supportedLanguage = ["en-US", "tr", "nl-NL"];

export const languageLabels = {
  "en-US": "English (US)",
  "en": "English (US)",
  tr: "Turkish (TR)",
  "tr-TR": "Turkish (TR)",
  "nl-NL": "Dutch (NL)",
  "nl": "Dutch (NL)",
};

export const adminType = {
  "3SCAdmin": "3SCAdmin",
  "Client Admin": "Client Admin",
};

export const createThemeSelect = (theme) => {
  return {
    ...theme,
    borderRadius: 2,
    colors: {
      ...theme.colors,
      primary25: "#F2F2F2",
      primary: "#E94F1C",
    },
  };
};

export const userEditInitialValues = {
  organization: "",
  first_name: "",
  last_name: "",
  email: "",
  mobile_country_code: "",
  mobile: "",
  team: "",
  business_unit: "",
  address_line1: "",
  address_line2: "",
  country: null,
  state: null,
  city: null,
  pincode: "",
  roles: "",
};

export const getInTouch = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  organization: "",
  designation: "",
  date: "",
  time: "",
};

export const phoneInputValidateMsg = "This field is mandatory";
export const activateSNOPMessage = "Activate the SNOP to access";
export const activateSNOEMessage = "Activate the S&OE to access";
export const ENABLE_FOR_MENU = [SNOP.name, PAI.name, SNOE.name];
export const nameValidation = [
  "required",
  "alpha_num_dash_space",
  { max: "64" },
];
export const APPBAR_MENU = {
  IBP: "Integrated Business Planning",
  EDM: "Enterprise Data Management",
  DTRM: "Risk Management & Digital Twin",
  ID: "Internal Dashboard",
  CX: "CarbonX",
  DH: "Data Health",
  GENAI: "Cortex",
  IOP: "Integrated Operations Planning",
};
export default constKeys;

export const colorPalette = {
  grey: "#72757a",
  green: "#1BD365",
};

export const menuRoutes = [
  {
    name: "Home",
    path: "",
    isNavigate: false,
  },
  {
    name: "About",
    path: "https://3scsolution.com/about-us",
    isNavigate: true,
  },
  {
    name: "Features",
    path: "features",
    isNavigate: false,
  },
  {
    name: "How it works?",
    path: "works",
    isNavigate: false,
  },
];

export const CLIENT_PERMISSIONS = [
  "BU_VIEWCONFIGURATION",
  "CLIENT_CREATEEDITCONFIGURATION",
  "ROLE_EDIT",
  "CLIENT_VIEWCONFIGURATION",
  "TEAM_CREATE",
  "USER_CREATE",
  "ROLE_CREATE",
  "ROLE_VIEW",
  "USER_VIEW",
  "TEAM_VIEW",
  "BU_CREATE",
  "BU_CREATEEDITCONFIGURATION",
  "TEAM_EDIT",
  "USER_EDIT",
  "BU_EDIT",
  "BU_VIEW",
];

export const SCAIFrontendParams = {
  ID: {
    id: "admin",
    name: "admin",
    host: import.meta.env.VITE_ADMIN_HOST,
    requireAuth: true,
  },
  DPAI: {
    id: "dpai",
    name: "dp",
    host: import.meta.env.VITE_DPAI_HOST,
    requireAuth: true,
  },
  DS_DASHBOARD: {
    id: "ds",
    name: "ds",
    host: import.meta.env.VITE_DS_HOST,
    requireAuth: true,
  },
  DT: {
    id: "dt",
    name: "dt",
    host: import.meta.env.VITE_DT_HOST,
  },
  EDM: {
    id: "edm",
    name: "edm",
    host: import.meta.env.VITE_EDM_HOST,
  },
  GENAI: {
    id: "gen-ai",
    name: "gen-ai",
    host: import.meta.env.VITE_GENAI_HOST,
  },
  DH: {
    id: "health",
    name: "health",
    host: import.meta.env.VITE_HEALTH_HOST,
  },
  PAI: {
    id: "product",
    name: "pp",
    host: import.meta.env.VITE_PRODUCT_HOST,
  },
  RM: {
    id: "riskai",
    name: "riskai",
    host: import.meta.env.VITE_RM_HOST,
  },
  SNOE: {
    id: "snoe",
    name: "snoe",
    host: import.meta.env.VITE_SNOE_HOST,
  },
  SNOP: {
    id: "snop",
    name: "snop",
    host: import.meta.env.VITE_SNOP_HOST,
  },
  SNP: {
    id: "snp",
    name: "snp",
    host: import.meta.env.VITE_SNP_HOST,
  },
  TMS: {
    id: "tms",
    name: "tms",
    host: import.meta.env.VITE_TMS_HOST,
  },
  IEO: {
    id: "ieo",
    name: "ieo",
    host: import.meta.env.VITE_IEO_HOST,
  },
  SS: {
    id: "rs",
    name: "rs",
    host: import.meta.env.VITE_SS_HOST,
  },
  DSAI: {
    id: "ds",
    name: "ds",
    host: import.meta.env.VITE_DSAI_HOST,
  },
  CORTEX: {
    id: "cortex",
    name: "cortex",
    host: import.meta.env.VITE_CORTEX_HOST,
  }
};

export const AUTH_SCREENS = {
  LOGIN: "login",
  FORGOT_PASSWORD: "forgot_password",
  EMAIL_SENT: "email_sent",
  RESET_PASSWORD: "reset_password",
};

export const LANGUAGES = ["English", "Spanish", "French", "German", "Japanese"];

export const FOOTER_YEAR = 2026;

